import { NavLink, Outlet } from "react-router-dom";
import clsx from "clsx";
import { useAuth } from "../auth/AuthContext";
import { NotificationsBell } from "../components/NotificationsBell";

interface NavGroup {
  title: string;
  items: { to: string; label: string; end?: boolean }[];
}

const NAV: NavGroup[] = [
  {
    title: "Обзор",
    items: [
      { to: "/", label: "Дашборд", end: true },
    ],
  },
  {
    title: "Пользователи",
    items: [
      { to: "/users", label: "Все пользователи", end: true },
      { to: "/users?role=ORGANIZER", label: "Организаторы" },
      { to: "/users?role=SUPPLIER", label: "Поставщики" },
      { to: "/users?role=CUSTOMER", label: "Клиенты" },
      { to: "/users?role=MANAGER_OF_SALES", label: "Менеджеры продаж" },
      { to: "/users?role=MODERATOR", label: "Модераторы" },
    ],
  },
  {
    title: "Верификация",
    items: [
      { to: "/verification/organizers", label: "Заявки организаторов" },
      { to: "/verification/suppliers", label: "Заявки поставщиков" },
    ],
  },
  {
    title: "Управление",
    items: [{ to: "/moderators", label: "Модераторы" }],
  },
];

const linkClass = (isActive: boolean) =>
  clsx(
    "block px-3 py-2 rounded-md text-sm transition-colors",
    isActive
      ? "bg-brand text-white font-medium"
      : "text-slate-300 hover:text-white hover:bg-slate-800",
  );

export const AdminLayout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="flex h-full">
      <aside className="w-64 shrink-0 bg-brand-dark text-slate-200 flex flex-col">
        <div className="px-5 py-4 border-b border-slate-800">
          <div className="text-lg font-semibold text-white">Veyu Admin</div>
          <div className="text-xs text-slate-400 mt-1">{user?.email}</div>
          <div className="text-xs text-slate-500">{user?.role}</div>
        </div>
        <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-5">
          {NAV.map((group) => (
            <div key={group.title}>
              <div className="px-3 mb-1 text-[10px] uppercase tracking-wider text-slate-500">
                {group.title}
              </div>
              <ul className="space-y-0.5">
                {group.items.map((item) => (
                  <li key={item.to}>
                    <NavLink to={item.to} end={item.end} className={({ isActive }) => linkClass(isActive)}>
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
        <div className="p-3 border-t border-slate-800">
          <button
            type="button"
            onClick={logout}
            className="w-full text-left px-3 py-2 rounded-md text-sm text-slate-300 hover:bg-slate-800 hover:text-white"
          >
            Выйти
          </button>
        </div>
      </aside>
      <main className="flex-1 overflow-y-auto bg-slate-50">
        <header className="sticky top-0 z-30 flex items-center justify-end border-b border-slate-200 bg-white px-6 py-2">
          <NotificationsBell />
        </header>
        <Outlet />
      </main>
    </div>
  );
};
